






































import { Component, Vue } from 'vue-property-decorator';

import { curCoreClient, CoreClient } from '@/services/CoreClient';
import { Info } from '@/types/core';
import { DateTime } from 'luxon';

import SectionHeader from '@/components/SectionHeader.vue';
import KeyValue from '@/components/KeyValue.vue';
import Loading from '@/components/Loading.vue';
import GroupAccessView from '@/components/access/GroupAccessView.vue';
import EnterpriseAccessView from '@/components/EnterpriseAccessView.vue';

@Component({
  components: {
    KeyValue,
    SectionHeader,
    Loading,
    GroupAccessView,
    EnterpriseAccessView,
  },
})
export default class UserProfile extends Vue {

  // our model
  info:Info = {} as Info;
  error:string = '';
  dateTime = DateTime;

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;

  async mounted() {

    const reply = await this.coreClient.getInfo();
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to retrieve user info: ${reply.errorMsg}`;
    
    // we update the state
    this.info = reply.info as Info;
  }
}
